import { Grid } from '@mui/material';
import { DetailsRow } from 'lib/ClientDataDetails/Fields';
import { generalEnum } from 'screens/Clients/utils/generalEnum';
import TemplateDetails from '../TemplateDetails';
import { useTranslation } from 'react-i18next';
import { LoanPartRowProps } from 'types/Client';
import { getStartdate } from 'screens/Clients/utils/calculateLoanParts';
import { formatLoanNumber } from 'utils/global';
import {
  ClientExtractLoanPartGuarantee,
  ClientExtractLoanPartRedemptionMethod,
  ClientExtractLoanPartCollectionInterval,
} from 'types/ClientDetailsModel';

export default function LoanPartDetails({ translationsRoot, loanPart }: LoanPartRowProps) {
  const { t } = useTranslation();
  const startDate = getStartdate(loanPart.interestPeriod);
  const loanNumber = loanPart.number ? formatLoanNumber(loanPart.number) : '-';

  return (
    <Grid container>
      <Grid item xs={12} md={6} p={2}>
        <TemplateDetails title={t(`${translationsRoot}.headerLoanpart`)}>
          <DetailsRow
            type="string"
            label={t(`${translationsRoot}.number`)}
            value={loanNumber}
            isLoanPart
          />
          <DetailsRow
            type="currency"
            label={t(`${translationsRoot}.principalSum`)}
            value={loanPart.principalSum}
            isLoanPart
          />
          <DetailsRow
            type="currency"
            label={t(`${translationsRoot}.residualDebt`)}
            value={loanPart.residualDebt}
            isLoanPart
          />
          <DetailsRow
            type="date"
            label={t(`${translationsRoot}.startDateLoanpart`)}
            value={loanPart.startDate}
            isLoanPart
          />
          <DetailsRow
            type="date"
            label={t(`${translationsRoot}.endDateLoanpart`)}
            value={loanPart.endDate}
            isLoanPart
          />
          <DetailsRow
            label={t(`${translationsRoot}.duration`)}
            value={loanPart.duration}
            isLoanPart
          />
          <DetailsRow
            type="string"
            label={t(`${translationsRoot}.technicalProductName`)}
            value={loanPart.product}
            isLoanPart
          />
          <DetailsRow
            type="string"
            label={t(`${translationsRoot}.redemptionMethod`)}
            value={generalEnum(
              'redemptionMethod',
              loanPart.redemptionMethod,
              ClientExtractLoanPartRedemptionMethod
            )}
            isLoanPart
          />
          <DetailsRow
            type="string"
            label={t(`${translationsRoot}.collectionInterval`)}
            value={generalEnum(
              'collectionInterval',
              loanPart.collectionInterval,
              ClientExtractLoanPartCollectionInterval
            )}
            isLoanPart
          />
          <DetailsRow
            type="string"
            label={t(`${translationsRoot}.warrantytype`)}
            value={generalEnum('guarantee', loanPart.guarantee, ClientExtractLoanPartGuarantee)}
            isLoanPart
          />
        </TemplateDetails>
      </Grid>
      <Grid item xs={12} md={6} p={2}>
        <TemplateDetails title={t(`${translationsRoot}.headerInterest`)}>
          <DetailsRow
            type="date"
            label={t(`${translationsRoot}.startDateInterestPeriod`)}
            value={startDate}
            isLoanPart
          />
          <DetailsRow
            type="date"
            label={t(`${translationsRoot}.endDateInterestPeriod`)}
            value={loanPart.interestPeriod?.renewalDate}
            isLoanPart
          />
          <DetailsRow
            label={t(`${translationsRoot}.fixedInterestPeriod`)}
            value={loanPart.interestPeriod?.duration}
            isLoanPart
          />
          <DetailsRow
            type="percentage"
            label={t(`${translationsRoot}.interestRate`)}
            value={loanPart.interestPeriod?.effectiveInterestRate}
            isLoanPart
          />
          <DetailsRow
            label={t(`${translationsRoot}.remainingPeriod`)}
            value={loanPart.interestPeriod?.remainingDuration}
            isLoanPart
          />
        </TemplateDetails>
      </Grid>
    </Grid>
  );
}
